// extracted by mini-css-extract-plugin
export var container = "styles-module--container--eEDgc";
export var items = "styles-module--items---Umsk";
export var aboutItem = "styles-module--aboutItem--NW6Du";
export var aboutImage = "styles-module--aboutImage--vtWxl";
export var recentPosts = "styles-module--recentPosts--L8bjx";
export var dots = "styles-module--dots--nVwIm";